import React, { useState } from "react";
import Paper from "components/StyledPaper";
import Typography from "components/Typography";
import { Switch, Select, TextField } from "components/Fields";
import { MenuItem } from "@material-ui/core";
import InheritedValueIcon from "./InheritedValueIcon";

const RentIncreaseFields = ({ tenancyContractData, propertyContractData, updateTenancyContract }) => {

	const enabledValue = tenancyContractData.rentIncrease?.enabled ?? propertyContractData.rentIncrease.enabled;
	const isEnabledInherited = tenancyContractData.rentIncrease?.enabled == undefined || tenancyContractData.rentIncrease?.enabled == null;

	const dateInitialValue = tenancyContractData.rentIncrease?.date ?? propertyContractData.rentIncrease.date;
	const isDateInherited = !tenancyContractData.rentIncrease?.date || tenancyContractData.rentIncrease?.date === "";
	const [date, setDate] = useState(dateInitialValue ?? "");

	const fromMonthValue = tenancyContractData.rentIncrease?.fromMonth ?? propertyContractData.rentIncrease.fromMonth ?? "";
	const isFromMonthInherited = !tenancyContractData.rentIncrease?.fromMonth || tenancyContractData.rentIncrease?.fromMonth === "";

	const toMonthValue = tenancyContractData.rentIncrease?.toMonth ?? propertyContractData.rentIncrease.toMonth ?? "";
	const isToMonthInherited = !tenancyContractData.rentIncrease?.toMonth || tenancyContractData.rentIncrease?.toMonth === "";

	const startsFromInitialValue = tenancyContractData.rentIncrease?.startsFrom ?? propertyContractData.rentIncrease.startsFrom ?? "";
	const isStartsFromInherited = !tenancyContractData.rentIncrease?.startsFrom || tenancyContractData.rentIncrease?.startsFrom == "";
    const [startsFrom, setStartsFrom] = useState(startsFromInitialValue);

	const months = [
		{ value: 1, label: "januar" },
		{ value: 2, label: "februar" },
		{ value: 3, label: "marts" },
		{ value: 4, label: "april" },
		{ value: 5, label: "maj" },
		{ value: 6, label: "juni" },
		{ value: 7, label: "juli" },
		{ value: 8, label: "august" },
		{ value: 9, label: "september" },
		{ value: 10, label: "oktober" },
		{ value: 11, label: "november" },
		{ value: 12, label: "december" }
	];

	return (
		<Paper className="property-contract-details__other-fields">
			<Typography variant="subtitle">Lejeregulering</Typography>
			<div className="fields-section__container">
				<div className="fields-section__field">
					<Typography variant="label">Aktiveret {isEnabledInherited && <InheritedValueIcon />}</Typography>
					<div className="switch-container">
						<Switch
							checked={enabledValue}
							onChange={(e) => updateTenancyContract({ rentIncrease: { enabled: e.target.checked } })}
						/>
					</div>
				</div>
				<div className="fields-section__field">
                    <Typography variant="label">Date {isDateInherited && <InheritedValueIcon />}</Typography>
                    <TextField
                        value={date ?? ""}
                        type="date"
                        onChange={(event) => setDate(event.target.value)}
                        onExit={() => setDate(dateInitialValue)}
                        onFinish={() => {
                            date !== dateInitialValue && updateTenancyContract({ rentIncrease: { date: date } })
                        }}
                    />
                </div>
				<div className="fields-section__field">
					<Typography variant="label">Fra måned {isFromMonthInherited && <InheritedValueIcon />}</Typography>
					<Select
						value={fromMonthValue}
						onChange={(e) => {
							updateTenancyContract({ rentIncrease: { fromMonth: e.target.value } })
						}}>
						{months.map(month => (
							<MenuItem key={month.value} value={month.value}>
								{month.label}
							</MenuItem>
						))}
					</Select>
				</div>
				<div className="fields-section__field">
					<Typography variant="label">Til måned {isToMonthInherited && <InheritedValueIcon />}</Typography>
					<Select
						value={toMonthValue}
						onChange={(e) => {
							updateTenancyContract({ rentIncrease: { toMonth: e.target.value } })
						}}>
						{months.map(month => (
							<MenuItem key={month.value} value={month.value}>
								{month.label}
							</MenuItem>
						))}
					</Select>
				</div>
				<div className="fields-section__field">
                    <Typography variant="label">Starts From {isStartsFromInherited && <InheritedValueIcon />}</Typography>
                    <TextField
                        value={startsFrom ?? ""}
                        type="date"
                        onChange={(event) => setStartsFrom(event.target.value)}
                        onExit={() => setStartsFrom(startsFromInitialValue)}
                        onFinish={() => {
                            date !== startsFromInitialValue && updateTenancyContract({ rentIncrease: { startsFrom: startsFrom } })
                        }}
                    />
                </div>
			</div>
		</Paper>
	);
}

export default RentIncreaseFields;